import { useEffect, useState } from "react";
import Header from "./components/Header";
import Layout from "./components/Layout";
import { ToastProvider } from "./components/Toast";
import Countries from "./pages/Countries";
import Localizations from "./pages/Localizations";
import Categories from "./pages/Categories";
import Locales from "./pages/Locales";
import Diagnostics from "./pages/Diagnostics";
import Settings from "./pages/Settings";
import Login from "./pages/Login";
import { api } from "./api";

type Page = "countries" | "localizations" | "categories" | "locales" | "diagnostics" | "settings";
type Auth = "checking" | "in" | "out";

function pageFromHash(): Page {
  const h = window.location.hash.replace(/^#\/?/, "");
  if (
    h === "localizations" ||
    h === "categories" ||
    h === "locales" ||
    h === "diagnostics" ||
    h === "settings"
  ) {
    return h;
  }
  return "countries";
}

export default function App() {
  const [page, setPage] = useState<Page>(pageFromHash());
  const [auth, setAuth] = useState<Auth>("checking");

  useEffect(() => {
    const onHash = () => setPage(pageFromHash());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  useEffect(() => {
    api
      .me()
      .then(() => setAuth("in"))
      .catch(() => setAuth("out"));
  }, []);

  if (auth === "checking") {
    return <div className="min-h-screen" />;
  }
  if (auth === "out") {
    return <Login onSuccess={() => setAuth("in")} />;
  }

  return (
    <ToastProvider>
      <div className="min-h-screen">
        <Header active={page} onLogout={() => setAuth("out")} />
        <Layout>
          {page === "countries" && <Countries />}
          {page === "localizations" && <Localizations />}
          {page === "categories" && <Categories />}
          {page === "locales" && <Locales />}
          {page === "diagnostics" && <Diagnostics />}
          {page === "settings" && <Settings />}
        </Layout>
      </div>
    </ToastProvider>
  );
}
